import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthProvider/AuthProvider";
import { useRoles } from "../security/RolesProvider/RolesProvider";
import { LinearProgress } from "@mui/material";

export const ProtectedRoute: React.FC<{ children: React.ReactNode }> = (
  props,
) => {
  const { user, isLogin, security, token } = useAuth();
  const location = useLocation();

  if (isLogin && security.length === 0) {
    return <LinearProgress />;
  }

  if (isLogin && token) {
    return <>{props.children}</>;
  }
  return (
    <Navigate to="/auth/login" replace state={{ path: location.pathname }} />
  );
};
